import FadeIn from './FadeIn';
import SectionEyebrow from './SectionEyebrow';

const WIDTH_MAP = {
  '3xl': 'max-w-3xl',
  '5xl': 'max-w-5xl',
  '6xl': 'max-w-6xl',
  '7xl': 'max-w-7xl',
};

export default function MarketingHero({
  eyebrow,
  title,
  accent,
  accentBlock = false,
  subtitle,
  meta,
  maxWidth = '5xl',
  compact = false,
  children,
}) {
  const containerClass = WIDTH_MAP[maxWidth] || WIDTH_MAP['5xl'];

  return (
    <section
      className={`marketing-hero${compact ? ' marketing-hero--compact' : ''}`}
    >
      <div className={`${containerClass} mx-auto px-8 lg:px-12`}>
        {eyebrow && (
          <FadeIn delay={0.1}>
            <SectionEyebrow>{eyebrow}</SectionEyebrow>
          </FadeIn>
        )}

        {title && (
          <FadeIn delay={0.2}>
            <h1
              className="landing-heading"
              style={{
                fontSize: 'clamp(2.25rem, 4.5vw, 3.75rem)',
                lineHeight: 1.08,
                letterSpacing: '-0.035em',
                color: 'var(--text-primary)',
                marginBottom: subtitle || meta ? '1.5rem' : 0,
                maxWidth: 800,
              }}
            >
              {title}
              {accent && (
                <>
                  {accentBlock ? (
                    <span
                      className="headline-accent hero-headline-accent"
                      style={{ display: 'block', marginTop: '0.04em' }}
                    >
                      {accent}
                    </span>
                  ) : (
                    <>
                      {' '}
                      <span className="headline-accent hero-headline-accent">{accent}</span>
                    </>
                  )}
                </>
              )}
            </h1>
          </FadeIn>
        )}

        {subtitle && (
          <FadeIn delay={0.32}>
            <p className="marketing-hero__subtitle">{subtitle}</p>
          </FadeIn>
        )}

        {meta && (
          <FadeIn delay={0.38}>
            <p className="marketing-hero__meta">{meta}</p>
          </FadeIn>
        )}

        {children}
      </div>
    </section>
  );
}
